import React from 'react';
import cn from 'classnames';
import {motion, MotionStyle} from 'framer-motion';

interface IProps {
    className?: string;
    icon: React.JSX.Element;
    label?: string;
    quantity?: number;
    labelClassName?: string;
    badgeClassName?: string;
    onClick?: () => void;
    isLoading?: boolean;
    arialLabel?: string;
    style?: MotionStyle;
    [key: string]: unknown;
}

function IconButton({
    className,
    icon,
    label,
    quantity = 0,
    labelClassName,
    badgeClassName,
    isLoading = false,
    onClick,
    arialLabel,
    style,
    ...props
}: Readonly<IProps>) {
    const iconTextClass = cn('relative items-center justify-center', className);

    return (
        <motion.button onTap={onClick} aria-label={arialLabel} style={style} {...props}>
            <div className={iconTextClass}>
                {quantity > 0 && (
                    <>
                        {isLoading && (
                            <span className="absolute -right-[7px] -top-[4px] inline-flex h-3.5 w-3.5 animate-ping rounded-full bg-red-600 opacity-75 md:bg-yellow-600"></span>
                        )}
                        <span
                            className={cn(
                                badgeClassName,
                                'absolute -right-[6px] -top-[6px] z-1 flex items-center justify-center rounded-full bg-KPZ_Red_Price text-[10px] md:bg-KPZ_Yellow_Cart',
                                quantity >= 10 ? 'py-px px-[2px]' : 'h-4 w-4 p-px',
                            )}>
                            <span>{quantity > 99 ? '99+' : quantity}</span>
                        </span>
                    </>
                )}
                {icon}

                <span className={`${labelClassName} text-sm`}>{label}</span>
            </div>
        </motion.button>
    );
}

export default IconButton;
